import React from "react";
import { PageShell, Section } from "../components/landing/PageShell";
import { CONTACT_EMAIL } from "../data/site";

export default function Terms() {
  return (
    <PageShell
      title="Terms of Service"
      subtitle="The simple, fair terms for using SisterSafe and being part of our community."
    >
      <p className="text-sm text-[#8AA583]">Last updated: June 2026</p>

      <Section heading="Acceptance of terms">
        <p>
          By joining the SisterSafe waitlist or beta program, or by using our services, you
          agree to these Terms of Service. If you do not agree, please do not use SisterSafe.
        </p>
      </Section>

      <Section heading="Using SisterSafe">
        <p>
          SisterSafe is a personal safety network designed to help you stay connected to
          people you trust. It is a supportive tool and is not a replacement for emergency
          services. In an emergency, always contact your local emergency number.
        </p>
      </Section>

      <Section heading="Your account & community">
        <p>
          You are responsible for keeping your account secure and for the accuracy of the
          information you provide. Our community is rooted in trust and respect. Abusive,
          harmful, or fraudulent behaviour may result in removal.
        </p>
      </Section>

      <Section heading="Beta program">
        <p>
          Beta features are provided as-is and may change as we improve the experience. We
          welcome your feedback to help shape the future of women's safety.
        </p>
      </Section>

      <Section heading="Changes to these terms">
        <p>
          We may update these terms from time to time. We'll let you know about meaningful
          changes, and continued use means you accept the updated terms.
        </p>
      </Section>

      <Section heading="Contact us">
        <p>
          Questions about these terms? Email us at{" "}
          <a className="font-medium text-[#2F5E43] underline" href={`mailto:${CONTACT_EMAIL}`}>
            {CONTACT_EMAIL}
          </a>
          .
        </p>
      </Section>
    </PageShell>
  );
}
